import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
const sectionCss = "s1yn5pga";
const headingCss = "h1q7iueo";
const gridCss = "g1004hce";
const cardCss = "c8q0jv9";
const stepNumCss = "spc8ju4";
const StepCard = ({
  step,
  title,
  body
}) => <div className={cardCss} data-testid={`callie-step-${step}`}>
    <div className={stepNumCss}>{step}</div>
    <div>
      <TitleText level="4" size="x-small">{title}</TitleText>
      <BodyText>{body}</BodyText>
    </div>
  </div>;
export const CallieSteps = () => <FlexLayout direction="column" gap="16" className={sectionCss} data-testid="callie-steps">
    <TitleText className={headingCss} level="3" size="medium">
      {I18n.t('publisher.home.scheduling_subsection.callie.steps.heading')}
    </TitleText>
    <div className={gridCss}>
      <StepCard step={1} title={I18n.t('publisher.home.scheduling_subsection.callie.steps.step_1_title')} body={HtmlParser(I18n.t('publisher.home.scheduling_subsection.callie.steps.step_1_body'))} />
      <StepCard step={2} title={I18n.t('publisher.home.scheduling_subsection.callie.steps.step_2_title')} body={HtmlParser(I18n.t('publisher.home.scheduling_subsection.callie.steps.step_2_body'))} />
      <StepCard step={3} title={I18n.t('publisher.home.scheduling_subsection.callie.steps.step_3_title')} body={I18n.t('publisher.home.scheduling_subsection.callie.steps.step_3_body')} />
    </div>
  </FlexLayout>;

require("./callie_steps.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie_steps.js");